//
// Copyright 2020 DXOS.org
//

import { SpaceInfoPanel } from './SpaceInfoPanel';

export * from './SyncStateInfo';

export default SpaceInfoPanel;
